"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankUserMedal = void 0;
var RankUserMedal;
(function (RankUserMedal) {
    RankUserMedal["Gold"] = "gold";
    RankUserMedal["Silver"] = "silver";
    RankUserMedal["Bronze"] = "bronze";
    RankUserMedal["None"] = "none";
})(RankUserMedal = exports.RankUserMedal || (exports.RankUserMedal = {}));
//# sourceMappingURL=rank-user-medal.js.map